import { useContext, useMemo } from 'react'
import { BsChevronDown } from 'react-icons/bs'
import {
  FiGrid,
  FiCalendar,
  FiShoppingCart,
  FiList,
  FiCheckSquare,
  // FiTruck,
} from 'react-icons/fi'
import { FaTrash, FaEdit, FaCheck, FaTimes } from 'react-icons/fa'
import { NavLink } from 'react-router-dom'
import { getUserInfo } from '_utils/localData'
import { DESKTOP } from '_utils/constant'
import { CollapseContext } from '../../../context/CollapseMenuContext'
import { DeviceUserContext } from '../../../context/DeviceUserContext'
import { ConsolidatedContext } from '../../../context/ConsolidatedContext'
import { ADMIN_SECTION_ITEMS } from '../../constant/constant'
import useConsolidated from '../../hooks/useConsolidated'
import useGroupManagement from '../../hooks/useGroupManagement'
import './style.scss'

function LeftMenuV2() {
  const userInfo = getUserInfo()
  const { isCollapse } = useContext(CollapseContext)
  const { listRef, count } = useContext(ConsolidatedContext)
  const { checkDeviceUser } = useContext(DeviceUserContext)

  const {
    myGroups,
    listGroupWithAdmin,
    infoGroupSelected,
    groupInitial,
    isGroupDropdownOpen,
    setIsGroupDropdownOpen,
    groupMenuRef,
    handleSelectGroupValue,
    getGroupIdSelected,
  } = useGroupManagement()

  const {
    editingId,
    editingName,
    setEditingName,
    handleDeleteConsolidated,
    handleEditClick,
    handleSaveEdit,
    handleCancelEdit,
  } = useConsolidated()

  const mainSectionItems = useMemo(
    () => [
      {
        id: 2,
        path: '/event/list-hosted-by-group',
        icon: <FiCalendar />,
        title: 'Hosted Events',
      },
      {
        id: 3,
        path: '/manage-orders',
        icon: <FiShoppingCart />,
        title: 'Order Management',
        children: Array.from({ length: count }, (_, index) => ({
          id: `3-${index + 1}`,
          path: `/manage-orders/list-${index + 1}`,
          title: listRef[index]?.name,
          consolidatedId: listRef[index],
        })),
        hasScroll: count > 5,
      },
      {
        id: 4,
        path: '/products-items',
        icon: <FiList />,
        title: 'Products / Items',
      },
      {
        id: 6,
        path: '/event/list-packing-list',
        icon: <FiCheckSquare />,
        title: 'Packing List',
      },
      // {
      //   id: 5,
      //   path: '/event/delivery-list',
      //   icon: <FiTruck />,
      //   title: 'Fulfilment',
      // },
    ],
    [count, listRef]
  )

  if (!userInfo?.isUsingFeature || checkDeviceUser !== DESKTOP) {
    return null
  }

  return (
    <div className={`drawer-v2 ${isCollapse ? 'is-collapse' : ''}`}>
      {myGroups && listGroupWithAdmin?.length > 0 && (
        <div className='drawer-group-wrapper' ref={groupMenuRef}>
          <div
            className='drawer-group'
            onClick={(e) => {
              e.stopPropagation()
              if (!isCollapse) {
                setIsGroupDropdownOpen((prev) => !prev)
              }
            }}
          >
            <div className='drawer-group-av'>
              {infoGroupSelected?.photoUrl ? (
                <img src={infoGroupSelected.photoUrl} alt={infoGroupSelected.groupName || 'Group'} />
              ) : (
                groupInitial
              )}
            </div>
            {!isCollapse && (
              <div className='drawer-group-info'>
                <div className='drawer-group-name'>
                  {infoGroupSelected?.groupName || 'Select Group'}
                </div>
                <span className='drawer-group-sub'>
                  {infoGroupSelected?.totalMembers || 0} members
                </span>
              </div>
            )}
            {!isCollapse && (
              <BsChevronDown
                className={`drawer-group-chevron ${isGroupDropdownOpen ? 'open' : ''}`}
              />
            )}
          </div>

          {isGroupDropdownOpen && !isCollapse && (
            <div className='drawer-group-dropdown'>
              {listGroupWithAdmin.map((group) => {
                const isSelected = group.gid === getGroupIdSelected()
                return (
                  <div
                    key={group.gid}
                    className={`group-item ${isSelected ? 'selected' : ''}`}
                    onClick={(e) => {
                      e.stopPropagation()
                      handleSelectGroupValue(group.gid)
                      setIsGroupDropdownOpen(false)
                    }}
                  >
                    <div className='group-item-av'>
                      {group.photoUrl ? (
                        <img src={group.photoUrl} alt={group.name || 'Group'} />
                      ) : (
                        group.name ? group.name.charAt(0).toUpperCase() : 'G'
                      )}
                    </div>
                    <div className='group-item-info'>
                      <div className='group-item-name'>{group.name}</div>
                      <div className='group-item-sub'>{group.totalMembers || 0} members</div>
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      )}

      <nav className='drawer-nav'>
        <NavLink
          to='/dashboard'
          className='drawer-item'
          activeClassName='active'
          exact
        >
          <span className='icons'><FiGrid /></span>
          <span className='drawer-item-title'>Dashboard</span>
          {isCollapse && <span className='tooltip-text'>Dashboard</span>}
        </NavLink>

        {!isCollapse && <div className='drawer-section'>Main</div>}
        {mainSectionItems.map((item) => (
          <div key={item.id} className='drawer-item-wrap'>
            <NavLink
              to={item.path}
              className='drawer-item'
              activeClassName='active'
              exact
            >
              <span className='icons'>{item.icon}</span>
              <span className='drawer-item-title'>{item.title}</span>
              {isCollapse && <span className='tooltip-text'>{item.title}</span>}
            </NavLink>

            {/* Consolidate list */}
            {item.children && !isCollapse && (
              <ul className={`sub-menu ${item.hasScroll ? 'has-scroll' : ''}`}>
                {item.children.map((child) => (
                  <li
                    key={child.id}
                    className='sub-menu-item'
                    style={editingId === child.id ? { paddingRight: '4px' } : {}}
                  >
                    {editingId === child.id ? (
                      <div className='edit-input-wrapper'>
                        <input
                          type='text'
                          value={editingName}
                          onChange={(e) => setEditingName(e.target.value)}
                          className='edit-input'
                          autoFocus
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') handleSaveEdit(child.consolidatedId)
                            if (e.key === 'Escape') handleCancelEdit()
                          }}
                        />
                        <div className='edit-actions'>
                          <FaCheck
                            style={{ color: '#009A97', cursor: 'pointer', fontSize: '13px' }}
                            title='Save'
                            onClick={() => handleSaveEdit(child.consolidatedId)}
                          />
                          <FaTimes
                            style={{ color: '#888780', cursor: 'pointer', fontSize: '13px' }}
                            title='Cancel'
                            onClick={handleCancelEdit}
                          />
                        </div>
                      </div>
                    ) : (
                      <>
                        <NavLink
                          to={child.path}
                          className='sub-menu-link'
                          activeClassName='active'
                          exact
                        >
                          <span>{child.title}</span>
                        </NavLink>
                        <div className='menu-actions'>
                          <FaEdit
                            style={{ color: '#888780', cursor: 'pointer', fontSize: '13px' }}
                            title='Edit'
                            onClick={() => handleEditClick(child)}
                          />
                          <FaTrash
                            style={{ color: '#888780', cursor: 'pointer', fontSize: '13px' }}
                            title='Delete'
                            onClick={(e) => handleDeleteConsolidated(child.consolidatedId.id, e)}
                          />
                        </div>
                      </>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}

        {!isCollapse && <div className='drawer-section' style={{ marginTop: '10px' }}>Administration</div>}
        {ADMIN_SECTION_ITEMS.map((item) => (
          <NavLink
            key={item.id}
            to={item.path}
            className='drawer-item'
            activeClassName='active'
            exact
          >
            <span className='icons'>{item.icon}</span>
            <span className='drawer-item-title'>{item.title}</span>
            {isCollapse && <span className='tooltip-text'>{item.title}</span>}
          </NavLink>
        ))}
      </nav>

      <div className='drawer-footer'>
        <div className='drawer-footer-av'>
          {infoGroupSelected?.photoUrl ? (
            <img src={infoGroupSelected.photoUrl} alt={infoGroupSelected.groupName || 'Group'} />
          ) : (
            groupInitial
          )}
        </div>
        {!isCollapse && (
          <div className='drawer-footer-info'>
            <div className='drawer-footer-name'>{infoGroupSelected?.groupName || 'My Group'}</div>
            <div className='drawer-footer-sub'>{userInfo?.name || 'User'}</div>
            <div className='drawer-footer-role'>Admin</div>
          </div>
        )}
      </div>
    </div>
  )
}

export default LeftMenuV2
